import styled from 'styled-components'     

export const ExampleComponent = styled.div.attrs({
})`
`;   

export const PasswordValidationContainer = styled.div.attrs({
})`            
    margin-bottom: 24px;
`;    